import script from "./AlignmentLine.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlignmentLine.vue?vue&type=script&lang=ts&setup=true"

import "./AlignmentLine.vue?vue&type=style&index=0&id=37fa6068&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37fa6068"]])

export default __exports__